import { __assign } from "tslib";
import React from "react";
import { MarkdownComponent } from "./MarkdownComponent";

function resolveHeadingPrefix(source, headingPrefix) {
  var hp = "";

  if (typeof headingPrefix === "function") {
    hp = headingPrefix(source);
  } else {
    hp = headingPrefix ? headingPrefix : "";
  }

  return hp;
}

export var MarkdownRenderEngine = function MarkdownRenderEngine(_a) {
  var source = _a.source,
      _b = _a.options,
      options = _b === void 0 ? {} : _b;
  var headingPrefix = resolveHeadingPrefix(source, options.headingPrefix);
  return React.createElement(MarkdownComponent, __assign({}, options, {
    source: source.content || source.rawContent,
    headingPrefix: headingPrefix,
    key: headingPrefix
  }));
};